import React from 'react';
import PostEngagementWidget from './PostEngagementWidget';

const PostEngagementWidgetBasic = () => (
  <PostEngagementWidget className="masonry-item w-[410px] h-[237px] rounded-lg flex flex-col" />
);

export default PostEngagementWidgetBasic;
